import { Box, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import StepperBarGraph from "../../../common/Graphs/StepperBarGraph";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";

function StairStepperGraphComponent({ history, classes, stepperGraphData }) {
  const [scrollToGraphViewStair, setScrollToGraphViewStair] = useState();
  const [selectWeek, setSelectedWeek] = useState(null); // This should be week number

  const handleValueChange = (e) => {
    setSelectedWeek(parseInt(e.target.value) + 1);
    setScrollToGraphViewStair(e.target.value);
  };
  useEffect(() => {
    if (scrollToGraphViewStair) {
      const setgraphview = document.getElementById("stairChallengeRef");
      if (setgraphview) {
        setgraphview.scrollIntoView({
          block: "end",
          inline: "end",
          behavior: "instant",
        });
      }
    }
  }, [scrollToGraphViewStair]);
  return (
    <Box py={4} id="stairChallengeRef">
      <h2 className={classes.chartTitle}>{stepperGraphData?.title} :</h2>
      <StepperBarGraph
        setSelectedWeek={setSelectedWeek}
        selectWeek={selectWeek}
        stepperGraphData={stepperGraphData}
        selectedWeekData={
          selectWeek
            ? stepperGraphData?.[`week ${selectWeek}`]
            : stepperGraphData?.[`week ${stepperGraphData?.firstWeek}`]
        }
        stairStepperValueChange={handleValueChange}
      />
    </Box>
  );
}

const styles = (theme) => ({
  mainContainer: {
    fontFamily: '"Karla", sans-serif',
    margin: "5px",
    marginInline: "20px",
    [theme.breakpoints.down("sm")]: { marginInline: "5px" },
  },
  dashBoardTitle: {
    letterSpacing: "-1px",
    fontWeight: "bold",
    padding: 0,
    fontSize: "40px",
    marginTop: 0,
    marginBottom: "0px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
    },
  },
  chartTitle: {
    letterSpacing: "-1px",
    marginBottom: 0,
    color: "#202260",
    fontWeight: "bold",
    fontSize: "35px",
    marginLeft: "10px",
    textTransform: "capitalize",
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
      marginLeft: "0px",
    },
  },
  titleContainer: {
    // border: "1px solid",
    color: "#202260",
    borderColor: "#d1d1d1",
    textAlign: "center",
  },
  datesContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginInline: "10px",
    "& .date2": {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    "& .scoreTitle": {
      marginTop: "5px",
      fontWeight: "600",
      fontSize: "26px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
  },
  doughnutChartContainer: {
    width: "100%",
    display: "flex",

    marginTop: "5px",
    justifyContent: "space-between",

    "& .doughnutItem": {
      // border: "1px solid",
      position: "relative",
      width: "100%",
      paddingBottom: "20px",
      borderColor: "#b3caf6",
      "& .cooperDate2": {
        display: "none",

        [theme.breakpoints.down("sm")]: {
          display: "block",
          fontSize: "18px",
          marginTop: "5px",
          marginLeft: "10px",
          fontWeight: "600",
        },
      },

      "& .doughnutLabel": {
        position: "absolute",
        left: "131px",
        top: "91px",
        width: "50px",
        fontSize: "small",
        fontWeight: "bold",
        [theme.breakpoints.down("sm")]: {
          left: "131px",
          top: "91px",
          width: "50px",
          fontSize: "small",
        },
      },
      "& .doughnutContainer": {
        margin: "0 auto",
        height: "200px",
        width: "200px",
        [theme.breakpoints.down("sm")]: {
          height: "150px",
          width: "150px",
        },
      },
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },

    "& .cooperLegendBlock": {
      display: "flex",
      justifyContent: "end",
      marginRight: "44px",
      gap: "10px",
      alignItems: "center",
      "& .legendBlock": {
        width: "40px",
        height: "18px",
        backgroundColor: "#FE7235",
        [theme.breakpoints.down("sm")]: {
          width: "30px",
          height: "12px",
        },
      },
      "& .legendBlockTitle": {
        fontSize: "20px",
        fontWeight: "500",
        [theme.breakpoints.down("sm")]: {
          fontSize: "16px",
          fontWeight: "500",
        },
      },
    },
  },
  stepsChallengeContainer: {
    marginTop: "20px",
  },
  individualGraphContainer: {
    marginTop: "20px",
  },
  horizontalBarContainer: {
    height: "30vh",
    width: "auto",
    display: "flex",
    gap: "20px",
    width: "100%",
    // position: "relative",
    [theme.breakpoints.down("sm")]: {
      height: "20vh",
      width: "auto",
    },
  },
  knowledgeSessionTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    "& .knowledgeSessionTitle": {
      marginBottom: 0,
      color: "#202260",
      fontWeight: "bold",
      fontSize: "35px",
      marginLeft: "10px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
        marginLeft: "0px",
      },
    },
    "& .legendBlock": {
      width: "40px",
      height: "18px",
      backgroundColor: "#FE7235",
      [theme.breakpoints.down("sm")]: {
        width: "30px",
        height: "12px",
      },
    },
    "& .legendBlockTitle": {
      fontSize: "20px",
      fontWeight: "500",
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
        fontWeight: "500",
      },
    },
    "& .attendanceContainer": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginRight: "120px",
      [theme.breakpoints.down("sm")]: {
        marginRight: "0px",
      },
    },
  },
  sessionIndicatorContainer: {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-between",
    gap: "32px",
    marginTop: "15px",
    [theme.breakpoints.down(1400)]: {
      gap: "18px",
      marginTop: "13px !important",
    },
    [theme.breakpoints.down(913)]: {
      gap: "65px",
      marginTop: "33px !important",
    },
    [theme.breakpoints.down(821)]: {
      gap: "36px",
      marginTop: "19px !important",
    },
    [theme.breakpoints.down(431)]: {
      gap: "25px",
      marginTop: "15px !important",
    },
    [theme.breakpoints.down(415)]: {
      gap: "23px",
      marginTop: "15px !important",
    },
    [theme.breakpoints.down(376)]: {
      gap: "12px",
      marginTop: "8px !important",
    },
    [theme.breakpoints.down(361)]: {
      gap: "16px",
    },
    "& .sessionText": {
      fontSize: "28px",
      fontWeight: "bold",
      padding: 0,
      margin: 0,
      [theme.breakpoints.down(1400)]: {
        fontSize: "18px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
  },
  stepsChallengeProgressContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "baseline",
    gap: "80px",
    [theme.breakpoints.down("sm")]: {
      gap: "20px",
      flexDirection: "column",
    },
    "& .progressBarContainer": {
      width: "60%",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },
  totalDetailsProg: {
    color: "black",
    fontWeight: "bold",
    fontSize: "28px",
    display: "flex",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexWrap: "nowrap",
      fontSize: "20px",
      height: "20%",
      justifyContent: "flex-start",
      margin: "0",
    },
    "& .stepsTitle": {
      color: "black",
      fontWeight: "bolder",
      fontSize: "26px",
      margin: "0",
      // marginLeft: "20px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
    },
  },
  breadcrumbs_container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    "& .breadcrumbs": {
      [theme.breakpoints.down("sm")]: {
        alignSelf: "start",
      },
    },
    "& .dashboard_logo": {
      [theme.breakpoints.down("sm")]: {
        alignSelf: "end",
      },
    },
  },
  knowledgeSessionContainer: {
    "& .legends": {
      display: "flex",
      gap: "20px",
      marginRight: "6%",
      justifyContent: "end",
      alignItems: "center",
      fontSize: "22px",
      fontWeight: "bold",
      [theme.breakpoints.down("sm")]: {
        gap: "10px",
        fontSize: "14px",
        marginRight: "0",
      },
      "& .attended_session": {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        "& .legend_block": {
          height: "18px",
          width: "45px",
          backgroundColor: "#FE7235",
          [theme.breakpoints.down("sm")]: {
            height: "11px",
            width: "37px",
          },
        },
      },
      "& .total_session": {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        "& .legend_block": {
          height: "10px",
          width: "45px",
          backgroundColor: "#9396E3",
          [theme.breakpoints.down("sm")]: {
            height: "5px",
            width: "37px",
          },
        },
      },
    },
  },
});

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter
)(StairStepperGraphComponent);
